import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import Login from '../views/auth/Login'
import ChangePassword from "../views/auth/ChangePassword";
import AnimalIndex from "../views/animal/AnimalIndex";
import AnimalCreate from "../views/animal/AnimalCreate";
import AnimalEdit from "../views/animal/AnimalEdit";
import AnimalShow from "../views/animal/AnimalShow";
import FamilyIndex from "../views/family/FamilyIndex";
import FoodIndex from "../views/food/FoodIndex";
import TransitIndex from "../views/transit/TransitIndex";
import TransitCreate from "../views/transit/TransitCreate";
import TransitEdit from "../views/transit/TransitEdit";
import TransitShow from "../views/transit/TransitShow";
import FoodShow from "../views/food/FoodShow";
import FoodEdit from "../views/food/FoodEdit";
import FoodCreate from "../views/food/FoodCreate";
import SpeciesIndex from "../views/species/SpeciesIndex";
import SpeciesShow from "../views/species/SpeciesShow";
import SpeciesEdit from "../views/species/SpeciesEdit";
import SpeciesCreate from "../views/species/SpeciesCreate";
import UserIndex from "../views/user/UserIndex";
import UserCreate from "../views/user/UserCreate";
import UserEdit from "../views/user/UserEdit";
import UserShow from "../views/user/UserShow";
import HealthStateEdit from "../views/healthState/HealthStateEdit";
import HealthStateCreate from "../views/healthState/HealthStateCreate";
import HealthStateIndex from "../views/healthState/HealthStateIndex";
import SurgeryIndex from "../views/surgery/SurgeryIndex";
import SurgeryCreate from "../views/surgery/SurgeryCreate";
import SurgeryEdit from "../views/surgery/SurgeryEdit";
import SurgeryShow from "../views/surgery/SurgeryShow";
import SurgeryArchiveIndex from "../views/surgeryArchive/SurgeryArchiveIndex";
import SurgeryTemplateIndex from "../views/surgeryTemplate/SurgeryTemplateIndex";
import SurgeryTemplateCreate from "../views/surgeryTemplate/SurgeryTemplateCreate";
import SurgeryTemplateEdit from "../views/surgeryTemplate/SurgeryTemplateEdit";
import SurgeryTemplateShow from "../views/surgeryTemplate/SurgeryTemplateShow";
import HospitalizationIndex from "../views/hospitalization/HospitalizationIndex";
import HospitalizationCreate from "../views/hospitalization/HospitalizationCreate";
import HospitalizationEdit from "../views/hospitalization/HospitalizationEdit";
import HospitalizationShow from "../views/hospitalization/HospitalizationShow";
import HospitalizationArchiveIndex from "../views/hospitalizationArchive/HospitalizationArchiveIndex";
import NoteIndex from "../views/note/NoteIndex";
import NoteCreate from "../views/note/NoteCreate";
import NoteEdit from "../views/note/NoteEdit";
import NoteShow from "../views/note/NoteShow";
import NoteArchiveIndex from "../views/noteArchive/NoteArchiveIndex";
import SurgeryForHospitalization from "../views/surgery/SurgeryForHospitalization";
import NoteForHospitalization from "../views/note/NoteForHospitalization";
import DailyStatusEdit from "../views/dailyStatus/DailyStatusEdit";
import DailyStatusCreate from "../views/dailyStatus/DailyStatusCreate";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login/:username?/:password?',
    name: 'Login',
    component: Login,
    meta: {
      guest: true
    }
  },
  {
    path: '/changePassword/:token?',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: {
      guest: true
    }
  },
  {
    path: '/animal/index',
    name: 'AnimalIndex',
    component: AnimalIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/animal/create',
    name: 'AnimalCreate',
    component: AnimalCreate,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/animal/edit/:animalId',
    name: 'AnimalEdit',
    component: AnimalEdit,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/animal/show/:animalId',
    name: 'AnimalShow',
    component: AnimalShow,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/dailyStatus/create/:hospitalizationId',
    name: 'DailyStatusCreate',
    component: DailyStatusCreate,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/dailyStatus/edit/:dailyStatusId',
    name: 'DailyStatusEdit',
    component: DailyStatusEdit,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/family/index',
    name: 'FamilyIndex',
    component: FamilyIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/food/index',
    name: 'FoodIndex',
    component: FoodIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/food/create',
    name: 'FoodCreate',
    component: FoodCreate,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/food/edit/:foodId',
    name: 'FoodEdit',
    component: FoodEdit,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/food/show/:foodId',
    name: 'FoodShow',
    component: FoodShow,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/healthState/index',
    name: 'HealthStateIndex',
    component: HealthStateIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/healthState/create',
    name: 'HealthStateCreate',
    component: HealthStateCreate,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/healthState/edit/:healthStateId',
    name: 'HealthStateEdit',
    component: HealthStateEdit,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/',
    name: 'HospitalizationIndex',
    component: HospitalizationIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/hospitalization/create',
    name: 'HospitalizationCreate',
    component: HospitalizationCreate,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/hospitalization/edit/:hospitalizationId',
    name: 'HospitalizationEdit',
    component: HospitalizationEdit,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/hospitalization/show/:hospitalizationId',
    name: 'HospitalizationShow',
    component: HospitalizationShow,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/hospitalizationArchive/index',
    name: 'HospitalizationArchiveIndex',
    component: HospitalizationArchiveIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/species/index',
    name: 'SpeciesIndex',
    component: SpeciesIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/species/create',
    name: 'SpeciesCreate',
    component: SpeciesCreate,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/species/edit/:speciesId',
    name: 'SpeciesEdit',
    component: SpeciesEdit,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/species/show/:speciesId',
    name: 'SpeciesShow',
    component: SpeciesShow,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/surgery/index',
    name: 'SurgeryIndex',
    component: SurgeryIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/surgery/create/:hospitalizationId?',
    name: 'SurgeryCreate',
    component: SurgeryCreate,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/surgery/edit/:surgeryId/:hospitalizationId?',
    name: 'SurgeryEdit',
    component: SurgeryEdit,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/surgery/show/:surgeryId',
    name: 'SurgeryShow',
    component: SurgeryShow,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/surgeryArchive/index',
    name: 'SurgeryArchiveIndex',
    component: SurgeryArchiveIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/surgery/forHospitalization/:hospitalizationId',
    name: 'SurgeryForHospitalization',
    component: SurgeryForHospitalization,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/surgeryTemplate/index',
    name: 'SurgeryTemplateIndex',
    component: SurgeryTemplateIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/surgeryTemplate/create',
    name: 'SurgeryTemplateCreate',
    component: SurgeryTemplateCreate,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/surgeryTemplate/edit/:surgeryTemplateId',
    name: 'SurgeryTemplateEdit',
    component: SurgeryTemplateEdit,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/surgeryTemplate/show/:surgeryTemplateId',
    name: 'SurgeryTemplateShow',
    component: SurgeryTemplateShow,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/transit/index',
    name: 'TransitIndex',
    component: TransitIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/transit/create',
    name: 'TransitCreate',
    component: TransitCreate,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/transit/edit/:transitId',
    name: 'TransitEdit',
    component: TransitEdit,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/transit/show/:transitId',
    name: 'TransitShow',
    component: TransitShow,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/user/index',
    name: 'UserIndex',
    component: UserIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/user/create',
    name: 'UserCreate',
    component: UserCreate,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/user/edit/:userId',
    name: 'UserEdit',
    component: UserEdit,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/user/show/:userId',
    name: 'UserShow',
    component: UserShow,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/note/index',
    name: 'NoteIndex',
    component: NoteIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/note/create/:hospitalizationId?',
    name: 'NoteCreate',
    component: NoteCreate,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/note/edit/:noteId/:hospitalizationId?',
    name: 'NoteEdit',
    component: NoteEdit,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/note/show/:noteId',
    name: 'NoteShow',
    component: NoteShow,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/noteArchive/index',
    name: 'NoteArchiveIndex',
    component: NoteArchiveIndex,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  },
  {
    path: '/note/forHospitalization/:hospitalizationId',
    name: 'NoteForHospitalization',
    component: NoteForHospitalization,
    meta: {
      requiresAuth: true,
      adminOnly: true
    }
  }
]

const router = new VueRouter({
  routes
})

// the meta: {requiresAuth: true} key. If a route has the meta key, it checks the store for a token; if present, it redirects them to the login route.
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {

    // Gestion pages réservées à l'admin
    if (to.meta.adminOnly) {
      if (store.getters.isAuthenticated && store.getters.isAdmin) {
        next()
        return
      } else {
        next('/login')
        return
      }
    }

    // Gestion pages réservées aux utilisateurs connectés
    if (store.getters.isAuthenticated) {
      next()
      return
    }

    next('/login')

  } else {
    next()
  }
})

// The meta: {guest: true} stops users that are logged in from accessing the routes with the guest meta.
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters.isAuthenticated) {
      next('/')
      return
    }
    next()
  } else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js